// @Version: 1.0.0
import { Component, Input } from '@angular/core';

@Component({
   selector: 'app-left-logo',
   templateUrl: './left-logo.component.html',
   standalone: false
})
export class LeftLogoComponent {

   @Input() showActionLogo: boolean = false; 
}
